<template lang="pug">
div.report-kpi
  loading(:active="busy", :is-full-page="false", loader="spinner")
  .kpi-header
    h3.kpi-value {{ displayValue(formattedValue) }}
    span.kpi-title {{ displayValue(title) }}
  .kpi-footer
    .kpi-change(:class="{ positive: isPositive, negative: !isPositive}" v-b-tooltip.hover.bottom, :title="`Comparison period: ${formattedPreviousValue}`")
      i(:class="arrowIconClass")
      | {{ displayValue(formattedTrendText) }}
</template>

<script>

export default {
  name: 'ReportKpi',
  props: {
    value: {
      type: Number,
    },
    previousValue: {
      type: Number,
    },
    title: {
      type: String,
    },
    trendPercentage: {
      type: Number,
    },
    prefix: { // $, €, ₪, ~, etc.
      type: String,
    },
    suffix: { // % etc.
      type: String,
    },
    busy: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    formatValue(val) {
      if(val !== null && val !== undefined){
        // Use toLocaleString for integers only, else keep full decimal precision (like CR metric)
        return `${Number.isInteger(val) ? val.toLocaleString() : val}${this.suffix || ''}`;
      }
      return val;
    },
    displayValue(val) { 
      return val !== null && val !== undefined ? val : '\u00A0'; // Returns a fallback space
    }
  },
  computed: {
    isPositive() {
      return this.trendPercentage >= 0;
    },
    formattedValue() {
       return this.formatValue(this.value);
    },
    formattedPreviousValue() {
       return this.formatValue(this.previousValue);
    },
    formattedTrendText() {
      return this.trendPercentage !== undefined && this.trendPercentage !== null ? `${this.trendPercentage}%` : this.trendPercentage;
    },
    arrowIconClass() {
      if (this.trendPercentage !== null && this.trendPercentage !== undefined){
        return this.isPositive ? 'la la-arrow-up' : 'la la-arrow-down';
      }
      return '';
    }
  },
};
</script>

<style scoped>
.report-kpi {
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 16px 12px;
  width: 100%;
  min-width: 0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  font-family: sans-serif;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: white;
  height: 100%;
  margin-bottom: 0;
}

.kpi-header {
  margin-bottom: 8px;
}

.kpi-value {
  font-size: 22px;
  font-weight: bold;
  margin: 0;
  word-break: break-word;
}

.kpi-title {
  font-size: 13px;
  color: #666;
  word-break: break-word;
}

.kpi-footer {
  display: flex;
  align-items: center;
}

.kpi-change {
  font-size: 13px;
  display: flex;
  align-items: center;
  cursor: help;
}

.kpi-change i {
  margin-right: 4px;
}

.kpi-change.positive {
  color: #28a745;
}

.kpi-change.negative {
  color: #dc3545;
}

@media (max-width: 576px) {
  .report-kpi {
    padding: 12px 10px;
    font-size: 90%;
  }

  .kpi-value {
    font-size: 18px;
  }

  .kpi-title,
  .kpi-change {
    font-size: 12px;
  }
}
</style>
